// extracted by mini-css-extract-plugin
export default {"link":"VU4Mnk","root":"UHSxqn","label":"w4Vxx6"};